
import { get } from '../helpers/api.helper';

export async function GetCustomer(id_customer) {
    try {
        return await get(`cliente/${id_customer}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetCustomerLikeName(name, pageSize, page) {
    try {
        return await get(`cliente/paginated?name=${name}&page=${page}&pageSize=${pageSize}`);
    } catch (error) {
        console.error('Ocorreu um erro durante a solicitação');
    }
}


export async function ListCustomers() {
    try {
        return await get(`cliente/`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}


export async function ListCustomersPaginate(pageSize, page, isPaginate) {
    try {
        return await get(`cliente/paginated?page=${page}&pageSize=${pageSize}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}


export async function GetCustomerByUser() {
    try {
        return await get(`cliente/user/get`);
    } catch (error) {
        console.error('Erro ao buscar registro');
    }
}


